import React, { useState, useEffect } from 'react';
import useData from '../../src/hooks/useData';
import { getPosts } from '../services/blogApi';
import BlogCategory from '../components/blog/BlogCategory';
import Button from '../components/shared/Button';
import Title from '../components/shared/Title';
import ContactForm from '../components/shared/ContactForm';
import PostsContainer from '../components/blog/PostsContainer';
import Loading from '../components/shared/Loading';

const Blog = () => {
  const [openForm, setOpenForm] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [categorySelected, setCategorySelected] = useState('All');
  const { topCategories, isLoading } = useData({
    getAllAnyWithFilters: getPosts,
    name: 'posts'
  });

  useEffect(() => {
    setInputValue('');
    setSearchTerm('');
  }, [categorySelected]);

  return (
    <>
      <div className="bg-custom md:px-52 py-20 px-10">
        <div className="3xl:max-w-[1500px] 3xl:inline-block">
          <h1>
            <Title text1="Blog" colorForText={1} isLight={true} />
          </h1>
          <p className="text-center font-light text-white-50 text-xl">
            If you want to keep up to date with our news, trends and life in the company, follow our blog.
          </p>
          <div className="text-center inline-block mt-4 ">
            <Button
              className="min-w-[48px] min-h-[48px] px-6 py-3 bg-blue-800 text-white-50 hover:bg-mid-blue-900 focus:bg-mid-blue-900 active:bg-mid-blue-900 flex justify-center items-center gap-1"
              onClick={() => setOpenForm(!openForm)}
            >
              {openForm ? 'Hide Form' : "Let's talk!"}
            </Button>
          </div>
          {openForm && (
            <div className="text-center p-5">
              <ContactForm />
            </div>
          )}
        </div>
      </div>

      <div className="relative w-full h-24">
        <div className="absolute inset-0 mt-5 flex justify-center items-center">
          <form
            className="md:flex items-center justify-center gap-4 grid"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="text"
              placeholder="Search posts..."
              className="form-control block px-4 py-2 h-10 text-light-grey-700 bg-white-50 bg-clip-padding border border-solid border-dark-grey-300 rounded transition ease-in-out m-0 focus:text-light-grey-700 focus:bg-white-50 focus:border-blue-600 focus:outline-none"
              value={inputValue}
              onChange={(e) => {
                const value = e.target.value;
                setInputValue(value);
                setSearchTerm(value);
              }}
            />
            <Button className="bg-blue-800 text-white-50 hover:bg-mid-blue-900 focus:bg-mid-blue-900 active:bg-mid-blue-900" type="submit">
              Search
            </Button>
          </form>
        </div>
      </div>

      <div className="xl:px-52 md:px-20 px-10 mb-28 mt-10">
        <div className="flex flex-wrap justify-center items-center gap-2 mb-5 text-center">
          <BlogCategory text="All" selected={categorySelected} setSelected={setCategorySelected} searchTerm={searchTerm} />
          {isLoading ? (
            <Loading />
          ) : (
            topCategories && topCategories.map((category) => <BlogCategory key={category} text={category} selected={categorySelected} setSelected={setCategorySelected} />)
          )}
        </div>
        <PostsContainer categorySelected={categorySelected} searchTerm={searchTerm} />
      </div>
    </>
  );
};

export default Blog;
